import { usePowerBiHost } from "bps-powerbi-helper";
import * as pbi from "powerbi-client";
import { FC } from "react";

import { useScreenSize } from "@bps/fluent-ui";
import { OpsReportInstance } from "@libs/api/gateways/plt-reports-ops/plt-reports-ops-gateway.dtos";

interface ReportDisplayProps {
  embedConfig: OpsReportInstance;
}

export const OpsReportDisplay: FC<ReportDisplayProps> = ({ embedConfig }) => {
  const screenSize = useScreenSize();
  const { divRef } = usePowerBiHost({
    accessToken: embedConfig.accessToken,
    embedUrl: embedConfig.embedUrl,
    tokenType: embedConfig.tokenType,
    type: embedConfig.type,
    id: embedConfig.id,
    datasetIds: embedConfig.datasetIds,
    settings: {
      filterPaneEnabled: false,
      navContentPaneEnabled: false,
      layoutType: pbi.models.LayoutType.Custom,
      customLayout: {
        pageSize: {
          type: pbi.models.PageSizeType.Custom,
          width: screenSize.width - 288,
          height: screenSize.height - 158
        } as pbi.models.ICustomPageSize,
        displayOption: pbi.models.DisplayOption.ActualSize
      }
    }
  } as pbi.models.IReportEmbedConfiguration);

  return (
    <div
      ref={ref => {
        divRef.current = ref;
      }}
      style={{ height: "100%" }}
    />
  );
};
